"use client";

import { useEffect, useState } from "react";

type ScrollMascotProps = {
  enabled?: boolean;
};

export function ScrollMascot({ enabled = true }: ScrollMascotProps) {
  const [pos, setPos] = useState({ x: 0, y: 0, visible: false });

  useEffect(() => {
    if (!enabled) {
      setPos((p) => ({ ...p, visible: false }));
      return;
    }
    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const sy = window.scrollY;
        const wh = window.innerHeight;
        const dh = document.documentElement.scrollHeight;
        const progress = Math.min(1, Math.max(0, sy / (dh - wh)));
        // Show after first viewport, hide near bottom
        const visible = sy > wh * 0.7 && progress < 0.92;
        // Float along right edge, gently bobbing with progress
        const x = window.innerWidth - 130 - Math.sin(progress * 6) * 30;
        const y = wh - 130 - Math.sin(progress * 4) * 20;
        setPos({ x, y, visible });
        ticking = false;
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [enabled]);

  return (
    <div
      className={`scroll-mascot ${pos.visible ? "visible" : ""}`}
      style={{ left: `${pos.x}px`, top: `${pos.y}px` }}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/kamibot-character/kamibot-portrait.png" alt="" />
      <span className="speech">!</span>
    </div>
  );
}
